import styled from "styled-components";

export const ErrorBoundaryContainer = styled.div`
    height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 5%;
    text-align: center;

    p {
        font-size: 1.1rem;
        line-height: 2rem;
    }
`;
